<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MouqKx/cover.jpeg?1684514559737" alt="This image is the cover for the book Rebirth of Sword Sovereign, Book 12"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rebirth of Sword Sovereign, Book 12
      </h1>
      <p class="bookDescription body article font2">
        <p><strong>Ye Feng, the good-for-nothing, died in vain in the mausoleum because he was expelled by his family because he could not cultivate. After being reborn into a Sword God from another world, she discovered that this body was actually a peerless physique that was rarely seen in a trillion people, the Limitless Chaos Body!</strong></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bu HuiDunYun, Babel Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?191c3d59